import './FileBrowseTool.less';
import React, {useState, useEffect} from 'react';
import Request from '../../../bootstrap/api/Request';
import PagingPanel from '../../../bootstrap/components/paging-panel/PagingPanel';
import Spinner from '../../../bootstrap/components/spinner/Spinner';
import __ from '../../i18n';
import Button from '../../../bootstrap/components/button/Button';

export default function FileBrowseTool(
    {
        FileListParcel,
        maxFiles = 12,
        renderThumbnail = (record) => null,
        getFileTitle = (record) => null,
        getFileError = (record) => null,
        getSelectedSummary = (value) => __('Selected ::count(PLURAL, 1 1 file, ! :@ files)', {count: value.length}),
        onDone = (value) => undefined,
        onCancel = () => undefined,
    }
) {

    const pageSize = 24;

    const [items, setItems] = useState([]);

    const [totalItems, setTotalItems] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    const [error, setError] = useState(null);

    const [page, setPage] = useState(0);

    const [keyword, setKeyword] = useState('');

    const [value, setValue] = useState([]);

    const selectOrDeselect = (newItem) => {
        if (maxFiles === 1) {
            setValue([newItem]);
            return;
        }

        const selectedItem = value.find(t => t.id === newItem.id);

        if (!selectedItem) {
            value.push(newItem);
        } else {
            const index = value.indexOf(selectedItem);
            value.splice(index, 1);
        }

        setValue([].concat(value));
    };

    const getParcel = () => {
        const search = keyword.trim() || null;

        const orders = [{key: 'id', isAsc: false}];

        const limit = pageSize;

        const offset = page * pageSize;

        return new FileListParcel({search, orders, limit, offset});
    };

    useEffect(() => {
        setIsLoading(true);
        setError(null);

        Request.add(getParcel())
            .then(data => {
                setItems(data.items);
                setTotalItems(data.total);
            })
            .catch(error => {
                setError(error.getMessage());
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [keyword, page]);

    let setKeywordTimer = null;

    const setKeywordDelay = (newKeyword) => {
        if (setKeywordTimer !== null) {
            clearTimeout(setKeywordTimer);
        }

        setKeywordTimer = setTimeout(() => setKeyword(newKeyword), 300);
    };

    const getIsSelected = (item) => {
        return value.find(t => t.id === item.id);
    };

    const getItemError = (item) => {
        if (maxFiles !== 1 && value.length === maxFiles && !getIsSelected(item)) {
            return __('Max selectable reached');
        }

        return getFileError(item);
    };

    return <div className="file-browse-tool">
        <div className="tool-header">
            <div className="left">
                <div className="selected-summary">
                    {getSelectedSummary(value)}
                </div>
            </div>

            <div className="right">
                {
                    error !== null &&
                    <div className="error">
                        {error}
                    </div>
                }
                {
                    isLoading &&
                    <Spinner/>
                }
                <input
                    type="text"
                    onKeyUp={ev => setKeywordDelay(ev.target.value)}
                    onChange={ev => setKeywordDelay(ev.target.value)}
                    onPaste={ev => setKeywordDelay(ev.target.value)}
                    placeholder={__('Search by title or ID')}
                />
            </div>
        </div>
        <div className="tool-body">
            {
                items.length > 0 &&
                <div className="grid-view">
                    <ul>
                        {
                            items.map(item => {
                                const error = getItemError(item);
                                const disabled = error !== null;
                                const selected = value.find(t => t.id === item.id);

                                return <li
                                    key={item.id}
                                    className={
                                        (disabled ? ' disabled' : '') +
                                        (selected ? ' selected' : '')
                                    }
                                    onClick={() => disabled || selectOrDeselect(item)}
                                    aria-label={error || getFileTitle(item)}
                                >
                                    <div className="thumbnail-wrapper">
                                        {renderThumbnail(item)}
                                    </div>
                                </li>;
                            })
                        }
                    </ul>
                </div>
            }
            {
                !isLoading &&
                error === null &&
                items.length === 0 &&
                <div className="empty-notify">
                    {__('No files uploaded yet')}
                </div>
            }
        </div>
        <PagingPanel
            currentPage={page}
            pageSize={pageSize}
            totalItems={totalItems}
            goTo={setPage}
        />
        <div className="bottom-bar">
            {
                value.length > 0 &&
                <Button
                    title={__('Done')}
                    onClick={() => onDone(value)}
                    appearance="solid-primary"
                    size="small"
                />
            }
            <Button
                title={__('Cancel')}
                onClick={() => onCancel()}
                appearance="borderless-neutral"
                size="small"
            />
        </div>
    </div>;
}

